import type {ReactNode} from 'react'

interface DragPreviewProps {
    children: ReactNode
    'data-testid'?: string
}

/**
 * Floating pill rendered inside a dnd-kit `DragOverlay` to represent the item
 * being dragged. Pair with a `DragHandle` on the source row.
 */
export function DragPreview({children, 'data-testid': testId}: DragPreviewProps) {
    return (
        <div
            className="flex items-center gap-2 rounded border bg-background px-3 py-2 shadow-lg text-sm font-medium opacity-90"
            data-testid={testId}
        >
            {children}
        </div>
    )
}
